import { os } from '@utils/device-utils';
import AcSwipe from 'ac-components/ac-swiper';
import classNames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import styles from './styles.scss';


const ClassesSection: FC = () => {
	const { width } = useResizeObserver();
	const phoneBetween = width < 768 ? 0 : 32
	const spaceBetween = width >= 1192 ? 24 : phoneBetween
	const { transData, local, list } = useTranslation('oneOnOne.class')
	const listRender = useMemo(() => {
		if (!Array.isArray(list)) return []
		return list.map((item, index) => {
			return (
				<div
					key={index}
					className={styles['li-item']}
				>
					<div className={styles['img-wrap']}>
						<img loading='lazy' src={item.img} alt="" />
					</div>
					<div className={styles['li-content']} >
						<h4>{item.title}</h4>
						<span>{item.content}</span>
					</div>
				</div>
			)
		})
	}, [list])


	return (
		<section className={classNames(styles['ac-1on1-classes'], styles[`ac-1on1-classes-${local}`])}>
			<div className={styles['ac-classes-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }}></div>
				<AcSwipe className={classNames(styles['ac-classes-banner'], 'ac-classes-banner')}
					loop={true}
					spaceBetween={spaceBetween}
					autoplay={width < 1192}
					slidesPerView={(width >= 1192) ? 3 : 'auto'}
					allowTouchMove={width < 1192}
				>{listRender}</AcSwipe>
			</div>
		</section >
	);
}

export default ClassesSection
